import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import {
  OAI_KEY,
  PGLI_KEY,
  PLAN_DETAILS
} from "../../Benefits/utils/constants";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const selectorPlanNameByPlanType = (planType: IPlanType): string => {
  const names: Record<IPlanType, string> = {
    WingspanOccupationalAccidentInsurance: PLAN_DETAILS[OAI_KEY].name,
    WingspanProfessionalLiabilityAndGeneralLiabilityInsurance:
      PLAN_DETAILS[PGLI_KEY].name,
    MeridioHealth: "Meridio Health"
  };

  return names[planType] || "Insurance plan";
};
